
import React from "react";
import { TableCell, TableRow } from "@/components/ui/table";
import PermissionSwitch from "./PermissionSwitch";
import { Permission, Role, Resource, PermissionType, resourceLabels } from "@/hooks/rollenbeheer/types";

interface PermissionRowProps {
  permission: Permission;
  role: Role;
  onUpdatePermission: (role: Role, resource: Resource, permissionType: PermissionType, value: boolean) => void;
}

const PermissionRow: React.FC<PermissionRowProps> = ({ permission, role, onUpdatePermission }) => {
  const { resource, read, write, delete: canDelete } = permission;
  
  return (
    <TableRow key={`${role}-${resource}-${permission.id}`}>
      <TableCell className="font-medium">
        {resourceLabels[resource]}
      </TableCell>
      <TableCell className="text-center">
        <PermissionSwitch
          role={role}
          resource={resource}
          permissionType="read"
          checked={read}
          onToggle={onUpdatePermission}
        />
      </TableCell>
      <TableCell className="text-center">
        <PermissionSwitch
          role={role}
          resource={resource}
          permissionType="write"
          checked={write}
          onToggle={onUpdatePermission}
        />
      </TableCell>
      <TableCell className="text-center">
        <PermissionSwitch
          role={role}
          resource={resource}
          permissionType="delete"
          checked={canDelete}
          onToggle={onUpdatePermission}
        />
      </TableCell>
    </TableRow>
  );
};

export default PermissionRow;
